var _style, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgBoldIconinline = function SvgBoldIconinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 135,
    height: 48,
    viewBox: "0 0 135 48"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bold-icon_inline_svg__gradient"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#EE424E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#121E6C"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.458 32.56h33.203C72.863 41.21 65.724 48 57.058 48c-8.665 0-15.803-6.79-16.601-15.44h.001zM16.77 13.98v33.943c8.456-.816 15.1-8.116 15.1-16.973 0-8.856-6.644-16.153-15.1-16.97zm40.29-.078c-8.664 0-15.803 6.794-16.602 15.443h33.203c-.798-8.65-7.937-15.443-16.603-15.443h.002zM0 26.292v21.71h13.524V0H0v26.292zM120.544 0v48h13.525V0h-13.525zm-18.248 30.952c0 1.078.102 2.13.291 3.153 1.357 7.38 7.382 13.1 14.81 13.817V13.979c-8.456.817-15.1 8.116-15.1 16.973h-.001zM80.501 48h13.524V0H80.501v48z"
  })));
};
export default SvgBoldIconinline;